import React from "react";
import "../styles/header.css";
import { NavLink } from "react-router-dom";
import { class_names } from "../data/links";
import logo from "../assets/icons/logo.png";

function Header() {
  return (
    <div classNameName="header">
      <nav className="navbar navbar-expand-lg ">
        <div className="container-fluid">
          <NavLink className="navbar-brand" to="/">
            <img src={logo} alt="" />
            <span className="slash-divider">/</span>
            <span className="brand">CBSELEARN</span>
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav  mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink className="nav-link" aria-current="page" to="/contact">
                  <button className="border-button">Contact</button>
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" aria-current="page" to="/">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/about" target="_blank">
                  About
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/terms" target="_blank">
                  Terms
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/privacy" target="_blank">
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <nav className="nav">
        <div className="tab">
          {class_names.map((solution) => (
            <NavLink
              className="nav-link"
              to={solution.title.replace(/\s+/g, "-").toLowerCase()}
            >
              <span className="one-line">{solution.title}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}

export default Header;